import React from 'react';
import { Typography, Box, Container, Grid, Stack, Paper } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { PHONE_DISPLAY } from '../theme';
import { QuoteForm } from './QuoteForm';
export function LeadForm() {
  return <Box component="section" id="quote-form" sx={{
    py: {
      xs: 8,
      md: 12
    },
    bgcolor: 'primary.main',
    color: 'white'
  }} data-id="element-77">
      <Container maxWidth="lg" data-id="element-78">
        <Grid container spacing={6} alignItems="center" data-id="element-79">
          <Grid item xs={12} md={6} data-id="element-80">
            <Typography variant="h6" color="secondary.main" fontWeight="bold" textTransform="uppercase" letterSpacing={1} gutterBottom data-id="element-81">
              Get Started Today
            </Typography>
            <Typography variant="h2" sx={{
            mb: 3,
            fontSize: {
              xs: '2.5rem',
              md: '3.5rem'
            }
          }} data-id="element-82">
              Request Your Free Consultation
            </Typography>
            <Typography variant="h6" sx={{
            mb: 5,
            fontWeight: 400,
            opacity: 0.9,
            lineHeight: 1.6
          }} data-id="element-83">
              Ready to transform your backyard? Fill out the form or give us a
              call. We'll discuss your vision, provide expert recommendations,
              and give you a detailed estimate.
            </Typography>

            <Stack spacing={4} data-id="element-84">
              <Box sx={{
              display: 'flex',
              alignItems: 'flex-start'
            }} data-id="element-85">
                <Box sx={{
                bgcolor: 'rgba(255,255,255,0.1)',
                p: 2,
                borderRadius: 2,
                mr: 3
              }} data-id="element-86">
                  <PhoneIcon color="secondary" fontSize="large" data-id="element-87" />
                </Box>
                <Box data-id="element-88">
                  <Typography variant="body2" color="secondary.main" fontWeight="bold" textTransform="uppercase" gutterBottom data-id="element-89">
                    Call Us Directly
                  </Typography>
                  <Typography variant="h5" fontWeight="bold" data-id="element-90">
                    {PHONE_DISPLAY}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{
              display: 'flex',
              alignItems: 'flex-start'
            }} data-id="element-91">
                <Box sx={{
                bgcolor: 'rgba(255,255,255,0.1)',
                p: 2,
                borderRadius: 2,
                mr: 3
              }} data-id="element-92">
                  <LocationOnIcon color="secondary" fontSize="large" data-id="element-93" />
                </Box>
                <Box data-id="element-94">
                  <Typography variant="body2" color="secondary.main" fontWeight="bold" textTransform="uppercase" gutterBottom data-id="element-95">
                    Service Area
                  </Typography>
                  <Typography variant="h5" fontWeight="bold" data-id="element-96">
                    Brentwood, CA & Beyond
                  </Typography>
                </Box>
              </Box>
            </Stack>
          </Grid>

          <Grid item xs={12} md={6} data-id="element-97">
            <Paper elevation={6} sx={{
            p: {
              xs: 3,
              md: 5
            },
            borderRadius: 3
          }} data-id="element-98">
              <QuoteForm data-id="element-99" />
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>;
}